import { withChildren } from '@builder.io/react';
import { createBuilderModule } from '../../register-builder/builder-module';
import { SplitTest } from './SplitTest';

export default createBuilderModule(withChildren(SplitTest), {
  name: 'SplitTest',
  friendlyName: 'Split Test',
  image: 'https://cdn.zappy.app/f2fc45dc1925282215c0a00a39c387bc.png',
  hideFromInsertMenu: true,
  inputs: [
    {
      name: 'splitName',
      type: 'string',
      required: true,
      helperText: 'The name of the corresponding split in Split.io',
    },
  ],
});
